import React from "react";
import { UserAuth } from "../components/AuthContext";
import { Link } from "react-router-dom";

import Listings from "../components/List";
import Map from "../components/Map";
import { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

export const Dashboard = () => {
  const { user } = UserAuth();
  const style = {
    display: "inline-block",
  };

  // const [listingData, setListingData] = useState([])
  // const [loading, setLoading] = useState([false])

  // useEffect (()=>{
  //   const fetchListings = async () => {
  //     setLoading(true)
  //     // const res = await fetch()
  //     // const {listings} = await res.json("NASA_url")
  //     setListingData(listings)
  //     setLoading(false)
  //   }
  //   fetchListings()

  //   console.log(listings)
  // }, [])

  return (
    <>
      <Grid container spacing={3} style={{ width: "100%" }}>
        <Grid item xs={12} md={4}>
          <Listings />
        </Grid>

        <Grid item xs={12} md={8}>
          <Map />
        </Grid>
      </Grid>
    </>
  );
};
export default Dashboard;
